import React, { useState} from "react";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
import axios from 'axios';
import { Navigate } from "react-router-dom";
 

const MarketingPayoutCreate = ()=>{
     const [approved, setApproved ] = useState('');
     const [timeTo, setTimeTo ] = useState('');
     const [timeFrom, setTimeFrom ] = useState('');
     const [payDesc, setPayDesc ] = useState('');
     const [date, setDate ] = useState('');
     const [amount, setAmount ] = useState('');
     const [msisdn, setMsisdn ] = useState('');
     const [redirect, setRedirect] = useState(false);
     const submit = async (e)=>{
         e.preventDefault();
         const {data} = await axios.post('marketingPayout', {
            approved:parseInt(approved),
            time_to:timeTo,
            time_from:timeFrom,
            pay_desc:payDesc,
            date,
            amount,
            msisdn,
        });
        console.log(data);
        setRedirect(true);
     }
    if(redirect){
        return <Navigate to={'/marketingPayouts'} />
    }
     return (
         <Wrapper pageTitle={"New MarketingPayout"}>
            <InnerNav createLink={'/marketingPayoutCreate'} listLink={'/marketingPayouts'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    
 
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Msisdn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Msisdn"
                        onChange = {e => setMsisdn(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount"
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">PayDesc </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="PayDesc"
                        onChange = {e => setPayDesc(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date </span>
                        <input type="date"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Date"
                        onChange = {e => setDate(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Time From </span>
                        <input type="time"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TimeFrom"
                        onChange = {e => setTimeFrom(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Time To </span>
                        <input type="time"
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TimeTo"
                        onChange = {e => setTimeTo(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Approved </span>
                        <select
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Approved"
                        onChange = {e => setApproved(e.target.value)}>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                            </select>  
                    </label>


                    <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                        <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                        onClick={submit}
                        > <FiSave /> <span className="ml-3">Save</span> </button>
                        </label>
                    </div>
                </div>
             </form>
        </Wrapper>
     );
};
export default MarketingPayoutCreate;